import { useCallback, useEffect, useState } from "react";
import { DlqRedriveInfoApiFactory } from "../../../lusca-search-api/LuscaSearchApiFactory";
import { Stage } from "../../../lusca-search-api/generated-src";

export interface DLQRedriveInfosResult {
  executionArn: string;
  status: string;
  startDate: string;
}

export interface DlqRedriveRequestItem {
  executionArn: string;
  stage: string;
  status: string;
  executionDate: string;
}

export const useDlqRedriveData = (selectedStage: Stage) => {
  const [pastRedrives, setPastRedrives] = useState<DlqRedriveRequestItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const dlqRedriveApi = DlqRedriveInfoApiFactory();
      const response = await dlqRedriveApi.getDLQRedrivesInfo(selectedStage);

      if (response.data && Array.isArray(response.data)) {
        const formattedRedrives = response.data.map(
          (execution: DLQRedriveInfosResult) =>
            ({
              executionArn: execution.executionArn,
              stage: selectedStage,
              status: execution.status,
              executionDate: execution.startDate,
            } as DlqRedriveRequestItem)
        );

        setPastRedrives(formattedRedrives);
      } else {
        setPastRedrives([]);
      }
    } catch (err) {
      console.error("Error fetching DLQ redrives:", err);
      setError("Failed to load DLQ redrive history");
      setPastRedrives([]);
    } finally {
      setLoading(false);
    }
  }, [selectedStage]);

  useEffect(() => {
    if (selectedStage) {
      refresh().catch(() => {
        setError("Failed to load DLQ redrive history");
      });
    }
  }, [selectedStage, refresh]);

  return { pastRedrives, loading, error, refresh };
};
